import React from "react";
import { GLOBAL_IMAGES } from "../../assets/asset";
import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";

const GradeCard = () => {
  const userData = localStorage.getItem("user");
  const user = userData
    ? JSON.parse(userData)
    : { user_name: "Sameer", email: "sameer@byte-digital.com.au" };
  return (
    <Link
      to="/yearsdashboard"
      className="settings-grade-card flex items-center p-1 w-full   transition  "
    >
      <img
        src={GLOBAL_IMAGES.child}
        alt="avatar"
        className="settings-grade-icon w-10 h-10"
      />
      <div className="settings-grade-copy ml-4">
        <p className="text-lg font-semibold">Select {user.user_name}’s Grade</p>

        <p className="text-sm text-gray-800">
          Select {user.user_name}’s Math grade so we can curate the right
          curricular for {user.user_name}
        </p>
      </div>
      <div className="ml-auto ">
        <ChevronRight />
      </div>
    </Link>
  );
};

export default GradeCard;
